<!-- 盘点历史 -->

<template>
    <div class="vipCons">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                       <!--  <div class="left search flex flex-align-center">
                            <input type="text" class="left" placeholder="请输入姓名或相关信息">
                            <i class="el-icon-search"></i>
                        </div> -->
                        <!-- <div class="right addBtn">
                            <button type="button" @click="dialogVisible=true"><i class="el-icon-plus"></i>添加员工</button>
                        </div> -->
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:10%">序号</th>
                                <th style="width:12%">会员</th>
                                <th style="width:16%">时间</th>
                                <th style="width:20%">流水号</th>
                                <th style="width:16%">金额</th>
                                <th style="width:16%">结账方式</th>
                                <th style="width:10%">商品</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:workData.length>10}">
                                    <tr v-for="(item,ind) in workData">
                                        <td style="width:10%" >
                                            <span v-text="ind+1+curPage*pageSize" v-if="item.id"></span>
                                            <span v-if="!item.id"></span>
                                        </td>
                                        <td style="width:12%" v-text="item.memberName"></td>
                                        <td style="width:16%"> {{item.paymentTime | numberToMonthDate('')}}</td>
                                        <td style="width:20%" v-text="item.code"></td>
                                        <td style="width:16%" v-text="item.amount"></td>
                                        <td style="width:16%" v-text="paytype[item.type]"></td>
                                        <td style="width:10%">
                                            <div v-if="item.id" class="btnInline">
                                                <span v-if="item.type == 'MEMBER_DEPOSIT'">--</span>
                                                <span v-if="item.type == 'SALES'" style="cursor:pointer;color:#9FB2D7;text-decoration: underline;" @click="cutDetail(item)">详情</span>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 分页器 -->
                <div class="pager flex flex-align-center">
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left" :class="{havePage:(curPage>0)}" @click="changePage(false)"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left" v-text="''+(curPage+1)"></span>
                                <span class="next flex flex-align-center flex-pack-center left" :class="{havePage:((curPage+1)<totalPage)}" @click="changePage(true)"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right" v-text="'第 '+(curPage+1)+' / '+totalPage+' 页'"></div>
                        <div class="totalPage flex flex-align-center right" v-text="'共'+totalElements+'条'"></div>
                    </div>
                </div>
            </div>
        </div>


        <el-dialog
            title="消费详情"
            :visible.sync="showPutAllMask"
            size="tiny">
            <div class="putAllInner">
               <!--  <div class="lossTotal flex flex-align-center">
                    <span class="span1">总计</span><span class="span2 blue" v-text="totalElements"></span><span class="span3">条记录</span>
                    <span class="span1">上缴</span><span class="span2 red" v-text='total.price'></span>
                    <span class="span3">元</span>
                </div> -->
                <div class="putAllTableBox">
                    <div >
                        <table>
                            <thead>
                                <tr>
                                    <th style="width:10%">序号</th>
                                    <th style="width:20%">商品名称</th>
                                    <th style="width:20%">时间</th>
                                    <th style="width:20%">数量</th>
                                    <th style="width:20%">金额</th>
                                </tr>
                            </thead>    
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table>
                                    <tbody>
                                        <tr v-for="(item,ind) in inventoryList">
                                            <td style="width:10%"><span v-text="ind+1+pageSize*WKcurPage"></span></td>
                                            <td style="width:20%"> <span v-text="item.productName"></span></td>
                                            <td style="width:20%"><span>{{item.updateTime | numberToTime('')}}</span></td>
                                            <td style="width:20%"><span v-text="item.quantity"></span></td>
                                            <td style="width:20%"><span v-text="item.salesPrice"></span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pag flex flex-align-center" id="pag">
                <div class="pagerCon clearfix">
                    <div class="pagerBtnBox right">
                        <div class="pagerBtn">
                            <span class="prev flex flex-align-center flex-pack-center left" :class="{havePage:WKcurPage>0}"><i class="el-icon-arrow-left" @click="changeDetailPage(false)"></i></span>
                            <span class="curPageNumber flex flex-align-center flex-pack-center left" v-text="''+(WKcurPage+1)"></span>
                            <span class="next flex flex-align-center flex-pack-center left" ><i class="el-icon-arrow-right" :class="{havePage:((WKcurPage+1)<WKtotalPage)}" @click="changeDetailPage(true)"></i></span>
                        </div>
                    </div>
                    <div class="curPage flex flex-align-center right" v-text="'第 '+(WKtotalElements>0?(WKcurPage+1):'0')+' / '+(WKtotalPage)+' 条'"></div>
                    <div class="totalPage flex flex-align-center right" v-text="'共'+WKtotalElements+'条'"></div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props:['curStoreId', 'pageSize'],
        data () {
            return {
                showPutAllMask:false,//交班明细控制按钮
                workData:[],
                curPage: 0,//当前页，用于切换页码
                totalPage: 1,//总共页
                totalElements: 0,//总共条
                paytype:{'MEMBER_DEPOSIT':'充值','SALES':'消费'},
                getBtn: true, // 控制翻页请求

                inventoryList:[],//交班明细
                allarr:[],
                WKcurPage: 0,//当前页，用于切换页码
                WKtotalPage: 1,//总共页
                WKtotalElements: 0,//总共条
            }
        },
        methods: {
            //列表翻页
            changePage: function ( boo ) {
                if ( boo ) {
                    if ( (this.curPage + 1) >= this.totalPage ) {
                        return;
                    }
                    this.curPage++;
                } else {
                    if ( this.curPage <= 0 ) {
                        return;
                    }
                    this.curPage--;
                }
                this.getWordData();
            },
            //明细翻页
            changeDetailPage: function ( boo ) {
                if ( boo ) {
                    if ( (this.WKcurPage + 1) >= this.WKtotalPage ) {
                        return;
                    }
                    this.WKcurPage++;
                } else {
                    if ( this.WKcurPage <= 0 ) {
                        return;
                    }
                    this.WKcurPage--;
                }
                this.getDetail();
            },
            //获取消费记录列表
            getWordData(){
                if ( !this.getBtn ) {
                    return;
                }
                this.getBtn = false;
                this.$http.get('/member-sales?storeId='+this.curStoreId+'&page='+this.curPage+'&pageSize='+this.pageSize).then((res)=>{
                    this.workData = res.data.content;
                    this.totalPage = res.data.totalPages;
                    this.totalElements = res.data.totalElements;
                    if( this.workData.length < this.pageSize ){
                        for(let i = 0, len = this.pageSize - this.workData.length; i < len; i++){
                            this.workData.push({})
                        }
                    }
                    for(let i = 0,len = this.workData.length;i<len;i++){
                        if(this.workData[i].id){
                            this.workData[i].amount = this.workData[i].amount.toFixed(2);
                        }
                    }
                    this.getBtn = true;
                }).catch(()=>{
                    this.getBtn = true;
                })
            },
            //更换某消费明细的id
            cutDetail(item) {
                this.WKcurPage = 0;
                this.allarr = item.items;
                this.showPutAllMask = true;
                this.WKtotalPage = (item.items.length%10==0)?parseInt(item.items.length/10):parseInt(item.items.length/10)+1;
                this.WKtotalElements = item.items.length;
                this.getDetail();
            },
            //分页函数
            getDetail: function () {
                this.inventoryList = [];
                let starNum = this.WKcurPage*10;//开始页码
                let  endNum = ((starNum+10)>=this.WKtotalElements)?this.WKtotalElements:(this.WKcurPage+10);//最后页码
                for(let i = starNum;i < endNum;i++){
                    if(this.allarr[i]){
                        // this.allarr[i].salesPrice = this.allarr[i].salesPrice.toFixed(2);
                        this.inventoryList.push(this.allarr[i]);
                    }
                }
            },

        },
        created: function () {
            for (var i = 0; i < this.pageSize; i++) {
                this.workData.push({});
            }
        },
        mounted: function () {
            this.getWordData();
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import "vipCons.scss";
</style>



// WEBPACK FOOTER //
// vipCons.vue?3ac6e632